
export const AccordionDataCopy = [
  {
    id: 1,
    title: "Introduction",
    details: [
      {
        id: 1,
        text: "Test your API key",
        reference: "api-key",
        title: "Introduction",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">API KEY</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/user/check-my-api-key?ApiKey=',
        method:'GET',
        path:"test-your-api-key",
        responseString:`
        {
          "status": boolean,
          "message": "Your API Key is working",
          "details": {
              "name": "full name",
              "email": "example@gmail.com"
          }
        }
        `,
        description:"Once you have your API key, send a GET request to ensure everything is ready."
      },
      // {
      //   id: 2,
      //   text: "Rate limits",
      //   headerHtml:`
      //   <div>
      //     <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
      //       <p style="color: #38435B;">HEADERS</p>
      //     </div>
      //     <div style="padding: 12px 0px;">
      //       <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
      //         <span style="font-weight: 700;">api_key</span>
      //         <span style="color: #898F9E;">string</span>
      //         <span style="color: #d26163;">REQUIRED</span>
      //       </p>
      //     </div>
      //   </div>
      //   `,
      //   queryParamsHtml:`
      //   <div>
      //     <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
      //       <p style="color: #38435B;">QUERY PARAMETERS</p>
      //     </div>
      //     <div style="padding: 12px 0px;">
      //       <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
      //         <span style="font-weight: 700;">limit</span>
      //         <span style="color: #898F9E;">string</span>
      //       </p>
      //       <p style="font-size: 14px; margin-top: 0px;">Used for pagination</p>
      //     </div>
      //   </div>
      //   `,
      //   urlString:'https://mail.coldsender.com/email-marketing/automation/delete-campaign-api-key?campaignId=',
      //   method:'DELETE',
      //   path:'rate-limits'
      // },
    ],
  },
  {
    id: 2,
    title: "Campaign",
    details: [
      {
        id: 1,
        title: "Campaign",
        reference: "campaign",
        text: "Get campaign list",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">limit</span>
              <span style="color: #898F9E;">string</span>
            </p>
            <p style="font-size: 14px; margin-top: 0px;">Used for pagination</p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/automation/get-campaign-list-api-key?limit=',
        method:'GET',
        responseString:
        `[{
          "name": "Campaign name",
          "status": "Ongoing",
          "campaignId": "657d91aa315ed1dfce9d63d6",
          "duration": {
              "countryDateTime": "",
              "startDate": "",
              "endDate": ""
          },
          "day": [
              {
                  "day": "Sunday",
                  "startTime": "0:0",
                  "endTime": "0:0"
              },
          ],
          "fromEmail": [
              {
                  "email": "surendra@blutechnosoft.com",
                  "name": "samantha",
                  "serviceName": "gmail"
              }
          ],
          "toEmail": [
              {
                  "email": "shara.app@gmail.com",
                  "firstname": "Sharath Appesh",
                  "lastname": ""
              }
          ],
          "ccEmail": [],
          "bccEmail": []
        }]`,
        path: "get-campaign-list",
        description: "Retrieve a list of campaigns based on the provided API key.",
      },
      {
        id: 2,
        title: "Campaign",
        reference:'campaign-status',
        text: "Get campaign status",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">campaignId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/automation/get-campaign-status-api-key?campaignId=',
        method:'GET',
        responseString:
        `[{
          "name": "Campaign name",
          "status": "Ongoing",
          "campaignId": "657d91aa315ed1dfce9d63d6",
          "duration": {
              "countryDateTime": "",
              "startDate": "",
              "endDate": ""
          },
          "day": [
              {
                  "day": "Sunday",
                  "startTime": "0:0",
                  "endTime": "0:0"
              },
          ],
          "fromEmail": [
              {
                  "email": "surendra@blutechnosoft.com",
                  "name": "samantha",
                  "serviceName": "gmail"
              }
          ],
          "toEmail": [
              {
                  "email": "shara.app@gmail.com",
                  "firstname": "Sharath Appesh",
                  "lastname": ""
              }
          ],
          "ccEmail": [],
          "bccEmail": []
        }]`,
        path:'get-campaign-status',
        description: "Retrieve the status of a specific campaign using the provided API key."
      },
      {
        id: 3,
        title: "Campaign",
        text: "Get campaign summary",
        reference:'campaign-summary',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">campaignId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/automation/view-campaign-summary-api-key?campaignId=',
        method:'POST',
        responseString:`
        {
          "campaignName": "hellosyuundfkndsf",
          "campaignStatus": "Ongoing",
          "CampaignCreatedDate": "2023-12-16T12:01:46.876Z",
          "totalEmailSent": 5,
          "totalEmailCount": 6,
          "totalCampaignSubscription": 0,
          "totalCampaignUnsubscription": 0,
          "totalCampaignOpened": 0,
          "totalCampaignClicked": 0,
          "averageCampaignOpened": 0,
          "averageCampaignClicked": 0,
          "graphDetails": []
      }`,
        path:'get-campaign-summary',
        description: "Retrieve a summary of a specific campaign using the provided API key.",

      },
      {
        id: 4,
        title: "Campaign",
        text: "Set campaign name",
        reference:'campaign-name',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;border-bottom: 1px solid #DDD;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">campaignId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
          <div style="padding: 12px 0px">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">campaignName</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/automation/set-campaign-name-api-key?campaignId=&campaignName',
        method:'PUT',
        responseString:`
        {
          "status": true,
          "message": "Campaign name changed successfully"
        }`,
        path:'set-campaign-name',
        description: "Set the name of a campaign using the provided API key.",
      },
      {
        id: 5,
        title: "Campaign",
        text: "Pause campaign",
        reference:'campaign-pause',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">campaignId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/automation/pause-campaign-api-key?campaignId=',
        method:'POST',
        responseString:`
        {
          "status": true,
          "message": "Campaign has beed paused"
        }`,
        path:'pause-campaign',
        description: "Pause a specific campaign using the provided API key.",
      },
      {
        id: 6,
        title: "Campaign",
        text: "Resume campaign",
        reference:'campaign-resume',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">campaignId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/automation/resume-campaign-api-key?campaignId=',
        method:'POST',
        responseString:`
        {
          "status": true,
          "message": "Campaign has been up and running"
        }
        `,
        path:'resume-campaign',
        description: "Resume a paused campaign using the provided API key.",
      },
      {
        id: 7,
        title: "Campaign",
        text: "Terminate campaign",
        reference:'campaign-terminate',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">campaignId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/automation/terminate-campaign-api-key?campaignId=',
        method:'DELETE',
        responseString:`
        {
          "status": true,
          "message": "Campaign has been terminated"
        }
        `,
        path:'terminate-campaign',
        description: "Terminate a specific campaign using the provided API key.",
      },
      {
        id: 8,
        title: "Campaign",
        text: "Delete campaign",
        reference:'campaign-delete',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">campaignId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/automation/delete-campaign-api-key?campaignId=',
        method:'DELETE',
        responseString:`
        {
          "status": true,
          "message": "Campaign deleted successfully"
        }`,
        path:'delete-campaign',
        description: "Delete a specific campaign using the provided API key.",
      },
    ],
  },
  {
    id: 3,
    title: "Leads",
    details: [
      {
        id: 1,
        title: "Leads",
        text: "Get leads list", 
        description: "Retrieve a list of leads.",
        reference:'get-lead',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">limit</span>
              <span style="color: #898F9E;">string</span>
            </p>
            <p style="font-size: 14px; margin-top: 0px;">Used for pagination</p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/contact/get-leads-list-api-key?limit=',
        method:'GET',
        responseString:
        `[
          {
            "userId": "656ee9e55e6136662bb0b69a",
            "name": "hellofun",
            "leadId": "657d4a4c10a6f5621da9c474",
            "leads": [
                {
                    "name": "Sharath Appesh ",
                    "email": "shara.app@gmail.com",
                    "phone": "7338465553",
                    "firstName": "Sharath Appesh",
                    "lastName": "",
                    "companyName": "",
                    "website": "",
                    "verifiedStatus": "Not Verified"
                },
            ]
        }
      ]
        `,
        path:'get-leads-list',        
      },
      {
        id: 2,
        title: "Leads",
        text: "Get leads details",
        description: "Retrieve details of a specific lead.",
        reference:'get-leads-details',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">leadId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/contact/get-lead-details-api-key?leadId=',
        method:'GET',
        responseString:
        `[
          {
            "userId": "656ee9e55e6136662bb0b69a",
            "name": "hellofun",
            "leadId": "657d4a4c10a6f5621da9c474",
            "leads": [
                {
                    "name": "Sharath Appesh ",
                    "email": "shara.app@gmail.com",
                    "phone": "7338465553",
                    "firstName": "Sharath Appesh",
                    "lastName": "",
                    "companyName": "",
                    "website": "",
                    "verifiedStatus": "Not Verified"
                },
            ]
        }
      ]`,
        path:'get-leads-details'
      },
      {
        id: 3,
        title: "Leads",
        text: "Add lead details to lead",
        description: "Add additional details to a lead.",
        reference:'add-lead',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">BODY</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">Object</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">leadId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/contact/add-leads-details-to-lead-api-key?leadId=',
        method:'PUT',
        responseString:`
        {
          "status": true,
          "message": "Leads details added to lead successfully"
        }
        `,
        path:'add-lead-details-to-lead',
      },
      {
        id: 4,
        title: "Leads",
        text: "Remove lead details from lead",
        description: "Remove specific details from a lead.",
        reference:'remove-lead',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">leadId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/contact/remove-leads-details-from-lead-api-key?leadId=',
        method:'DELETE',
        responseString:`
        {
          "status": true,
          "message": "Lead details removed from lead"
        }
        `,
        path:'remove-lead-details-from-lead',
      },
      {
        id: 5,
        title: "Leads",
        text: "Delete leads details",
        description: "Delete all details of a lead.",
        reference:'delete-lead',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">leadId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/contact/delete-lead-details?leadId=',
        method:'DELETE',
        responseString:`
        {
          "status": true,
          "message": "Lead details deleted successfully"
        }
        `,
        path:'delete-leads-details',
      },
    ],
  },
  {
    id: 4,
    title: "Warmups",
    details: [
      {
        id: 1,
        title: "Warmups",
        text: "Get warmup list",
        reference:'warmup-list',
    description: "Retrieve a list of warmups, including their details.",

        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">limit</span>
              <span style="color: #898F9E;">string</span>
            </p>
            <p style="font-size: 14px; margin-top: 0px;">Used for pagination</p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/warmup-campaign/get-warmup-list-api-key?limit=',
        method:'GET',
        responseString:
        `[{
          "warmupId": "659d3ab70850dba2070dfdc0",
          "status": "Pending",
          "fromEmail": {
              "email": "surendra@blutechnosoft.com",
              "name": "Surendra Parla Kuruva",
              "serviceName": "google-oauth"
          },
          "strategy": {
              "Type": "Steady",
              "StartingVolume": 15,
              "DailyVolumeIncrease": 15,
              "DailySendingGoal": 15
          },
          "mailContent": {
              "EmailType": "Specific",
              "EmailSubject": "Our campaign - snv",
              "EmailContent": "Html content"
          },
          "countryTimeZone": "(UTC+01:00) West Central Africa",
          "day": [
              {
                  "day": "Sunday",
                  "startTime": "0:0",
                  "endTime": "0:0"
              },
          ],
          "ReplyRate": 30,
          "DeadLine": "Sun Feb 04 2024 09:31:02 GMT+0000 (Coordinated Universal Time)"
      }]`,
        path:'get-warmup-list',
      },
      {
        id: 2,
        title: "Warmups",
        text: "Get warmup status",
        description: "Retrieve the status and details of a specific warmup.",
        reference:'warmup-status',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">warmupId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/warmup-campaign/get-warmup-status-api-key?warmupId=',
        method:'GET',
        responseString:`
        {
          "warmupId": "659d3ab70850dba2070dfdc0",
          "status": "Pending",
          "fromEmail": {
              "email": "surendra@blutechnosoft.com",
              "name": "Surendra Parla Kuruva",
              "serviceName": "google-oauth"
          },
          "strategy": {
              "Type": "Steady",
              "StartingVolume": 15,
              "DailyVolumeIncrease": 15,
              "DailySendingGoal": 15
          },
          "mailContent": {
              "EmailType": "Specific",
              "EmailSubject": "Our campaign - snv",
              "EmailContent": "HTML content"
          },
          "countryTimeZone": "(UTC+01:00) West Central Africa",
          "day": [
              {
                  "day": "Sunday",
                  "startTime": "0:0",
                  "endTime": "0:0"
              },
          ],
          "ReplyRate": 30,
          "DeadLine": "Sun Feb 04 2024 09:31:02 GMT+0000 (Coordinated Universal Time)"
      }
        `,
        path:'get-warmup-status'
      },
      {
        id: 3,
        title: "Warmups",
        text: "Get warmup analytic summary",
        description: "Retrieve a summary of analytics for a specific warmup.",
        reference:'warmup-summary',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">warmupId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/warmup-campaign/get-warmup-summary-api-key?warmupId=',
        method:'GET',
        responseString:`
        {
          "status": false,
          "message": "No analytic details present",
          "details": {}
        }
        `,
        path:'get-warmup-analytic-summary'
      },
      {
        id: 4,
        title: "Warmups",
        text: "Pause warmup status",
        reference:'pause-warmup-status',
        description: "Pause the status of a warmup campaign.",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">warmupId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/warmup-campaign/pause-warmup-api-key?warmupId=',
        method:'POST',
        responseString:`
        {
          "status": true,
          "message": "Email warm-up status is paused"
        }`,
        path:'pause-warmup-status',
      },
      {
        id: 5,
        title: "Warmups",
        text: "Resume warmup status",
        reference:'resume-warmup-status',
        description: "Resume the status of a paused warmup campaign.",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">warmupId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/warmup-campaign/resume-warmup-api-key?warmupId=',
        method:'POST',
        responseString:`
        {
          "status": true,
          "message": "Email warm-up is up and running"
        }`,
        path:'resume-warmup-status',
      },
      {
        id: 6,
        title: "Warmups",
        text: "Delete warmup",
        reference:'delete-warmup',
        description: "Delete details of a specific warmup campaign.",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        queryParamsHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">QUERY PARAMETERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">warmupId</span>
              <span style="color: #898F9E;">string</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/warmup-campaign/delete-warmup-api-key?warmupId=',
        method:'DELETE',
        responseString:`
        {
          "status": true,
          "message": "Warm up details deleted successfully"
        }`,
        path:'delete-warmup'
      },
    ],
  },
  {
    id: 5,
    title: "Account",
    details: [
      {
        id: 1,
        title: "Account",
        text: "Get user details",
        reference:'get-user-details',
        description: "Retrieve details of the authenticated user.",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/user/me-api-key',
        method:'GET',
        responseString:
        `"details": {
          "id": "656ee9e55e6136662bb0b69a",
          "firstname": "Sharath",
          "lastname": "Appesha",
          "email": "surendra@blutechnosoft.com",
          "phone": 7338465553
        }`,
        path:'get-user-details',
      },
      {
        id: 2,
        title: "Account",
        text: "Get user transaction details",
        reference:'user-transaction-details',
        description: "Retrieve transaction details for the authenticated user.",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/user/get-transaction-api-key',
        method:'GET',
        responseString:
        `[
          {
              "Plan": "65967ad8a3263b1ecabb3d74",
              "CreditAmount": -1,
              "CurrentBalance": 999,
              "Info": "Contact credit",
              "Details": "",
              "Date": "Fri Jan 05 2024 07:33:58 GMT+0000 (Coordinated Universal Time)",
              "_id": "6597b0e6eb80bd8c702a4805"
          },
        ]`,
        path:'get-user-transaction-details'
      },
      {
        id: 3,
        title: "Account",
        text: "Update user details",
        description: "Update details of the authenticated user.",
        reference:'update-user-details',
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">BODY</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">Object</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/user/update-details-api-key',
        method:'PUT',
        responseString:
`{
  "status": true,
  "message": "User details updated successfully"
}`,
path:'update-user-details'
      },
      {
        id: 4,
        border:'none',
        title: "Account",
        text: "Delete user details",
        reference:'delete-user-details',
        description: "Delete details of the authenticated user.",
        headerHtml:`
        <div>
          <div style="border-bottom: 1px solid #000; padding: 8px 0px;">
            <p style="color: #38435B;">HEADERS</p>
          </div>
          <div style="padding: 12px 0px;">
            <p style="display: flex; gap: 6px; align-items: center; font-size: 14px;">
              <span style="font-weight: 700;">api_key</span>
              <span style="color: #898F9E;">string</span>
              <span style="color: #d26163;">REQUIRED</span>
            </p>
          </div>
        </div>
        `,
        urlString:'https://mail.coldsender.com/email-marketing/user/delete-user-api-key',
        method:'DELETE',
        responseString:
`{
  "status": true,
  "message": "User details deleted successfully"
}`,
path:'delete-user-details',
      },
    ],
  },
];
